// Small-blind / big-blind marker: a blue chip with bold white letters (used beside the posted blind and on the seat).
export const BlindBadge = ({ kind, size = 26, className = "", testId }) => (
  <svg data-testid={testId} width={size} height={size} viewBox="0 0 40 40" className={`drop-shadow-[0_2px_3px_rgba(0,0,0,0.6)] ${className}`} aria-label={kind === "SB" ? "small blind" : "big blind"}>
    <defs>
      <radialGradient id={`blind-${kind}`} cx="35%" cy="30%" r="75%"><stop offset="0%" stopColor="#60a5fa" /><stop offset="55%" stopColor="#2563eb" /><stop offset="100%" stopColor="#1e3a8a" /></radialGradient>
    </defs>
    <circle cx="20" cy="20" r="19" fill={`url(#blind-${kind})`} stroke="#eff6ff" strokeWidth="2" />
    <circle cx="20" cy="20" r="14.5" fill="none" stroke="#bfdbfe" strokeWidth="1" strokeDasharray="4 3" opacity="0.7" />
    <text x="20" y="25.5" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="15" fill="#fff">{kind}</text>
  </svg>
);
